import { GalleryDto } from '@nusign/picflow-backend-types';

export const fixPermissions = (permissions: GalleryDto['permissions']) => {
  return <GalleryDto['permissions']>{
    ...permissions,
    can_review_if_authenticated: permissions.can_review_if_authenticated || permissions.can_review,
  };
};
